module.exports = __webpack_public_path__ + "static/media/quotes-white.09c03a94.svg";